export const PromotionSource = {
    NETWORK: 'network',
    CARDROOM: 'cardRoom',
} as const;
